const RELEASE_KEY_PATTERN = /^release(\.[a-z0-9]+(-[a-z0-9]+)*)+$/;

export const normalizeKey = (input: string): string => {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) return "";
  if (trimmed === "release") return "release.";
  return trimmed.startsWith("release.") ? trimmed : `release.${trimmed}`;
};

export const isValidKey = (normalized: string): boolean =>
  RELEASE_KEY_PATTERN.test(normalized);

export const keyValidationError = (input: string): string | null => {
  const normalized = normalizeKey(input);
  if (!normalized || normalized === "release.") return "Key is required";
  if (!isValidKey(normalized))
    return "Key must be kebab-case (e.g., release.awesome-new-feature or release.foo.v2)";
  return null;
};
